import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { FormGenerator } from '@microservices/wiskey-react-components'
import { Box, Typography } from '@mui/material'

import { NewModel } from '@components/NewModel'
import { SwitchTable } from '@components/SwitchTable'
import { Tab, TabPanel, Tabs } from '@components/Tabs'
import { Variables } from '@components/Variables'

import { ENTITY_TYPES_REQUEST, MODEL_TYPE, TIMELINE_ACTION_COLUMNS } from '@constants'

import { PageContext } from '../../TimeLineCreateOrEdit'

export const GeneralConfiguration = () => {
  const { t } = useTranslation()

  const { state, inputs, handlers } = useContext(PageContext)

  const {
    watchId,
    generalCurrentTab,
    watchGeneralActions,
    generalShowAddActionDialog,
    isTimeLineLoading,
  } = state

  const {
    handleChangeGeneralCurrentTab,
    handleOpenGeneralAddActionDialog,
    handleDeleteGeneralAction,
  } = handlers

  const { generalDataInputs, generalDataSearchInputs } = inputs

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={generalCurrentTab} onChange={handleChangeGeneralCurrentTab}>
          <Tab
            tabIndex={0}
            label={
              <Typography variant={'body2'}>
                {t(`timeLinesCreateOrEdit.general.tabs.data`)}
              </Typography>
            }
          />
          <Tab label={t(`timeLinesCreateOrEdit.general.tabs.actions`)} tabIndex={0} />
          <Tab label={t(`timeLinesCreateOrEdit.general.tabs.variables`)} tabIndex={1} />
        </Tabs>
      </Box>
      <TabPanel index={0} sx={{ p: 1 }} value={generalCurrentTab}>
        <NewModel isCodeDisabled={!!watchId} />
        <FormGenerator inputs={generalDataInputs} mainGridSpacing={0} sx={{ mt: 1 }} />
        {!isTimeLineLoading && generalDataSearchInputs.length > 0 && (
          <Box component='fieldset' mb={1}>
            <legend>{t('timeLinesCreateOrEdit.general.searchLegend')}</legend>
            <FormGenerator
              inputs={generalDataSearchInputs}
              mainGridSpacing={0}
              sx={{ flexDirection: 'column', alignItems: 'flex-start' }}
            />
          </Box>
        )}
      </TabPanel>
      <TabPanel index={1} sx={{ p: 1 }} value={generalCurrentTab}>
        <SwitchTable
          disablePagination
          showActionsColumn
          btnDisabled={!watchId}
          btnText={t(`timeLinesCreateOrEdit.addAction`)}
          columns={TIMELINE_ACTION_COLUMNS}
          rows={watchGeneralActions}
          showDialog={generalShowAddActionDialog}
          type={MODEL_TYPE.TIMELINE_ACTION}
          onDelete={handleDeleteGeneralAction}
          onShowDialog={handleOpenGeneralAddActionDialog}
          onEdit={params => {
            handleOpenGeneralAddActionDialog('edit', params.row.original.id)
          }}
        />
      </TabPanel>
      <TabPanel index={2} sx={{ p: 1 }} value={generalCurrentTab}>
        <Variables
          entityId={watchId}
          entityType={ENTITY_TYPES_REQUEST.TIME_TABLE}
          isEditEntity={Boolean(watchId)}
        />
      </TabPanel>
    </>
  )
}
